module.exports = __webpack_public_path__ + "img/musc-logo.82e86750.png";